import { FC } from 'react'
import {
  StyleCard,
  StyleRowWrapper,
  StyleLeftWrapper,
  StyleRightWrapper,
  StyleTag,
} from './style'
import Image from '@components/image'
import Typography from '@components/typography'
import Row from '@components/row'
import Svg from '@components/svg'
import Button from '@components/button'
interface InstituteProviderCardProps {
  provider: any
}
const InstituteProviderCard: FC<InstituteProviderCardProps> = ({
  provider,
}) => {
  return (
    <StyleCard>
      <StyleRowWrapper>
        <StyleLeftWrapper>
          <Image
            fallbackType="doctor"
            src={`${process.env.BUCKET_URL}/${provider?.avatar}`}
          />
        </StyleLeftWrapper>
        <StyleRightWrapper>
          <Typography content={provider?.name} size={14} />
          <Row colGap={10}>
            <StyleTag>
              <Svg svg="plusHeart" size={14} />
              {provider?.infos?.category}
            </StyleTag>
            <StyleTag>
              <Svg svg="medal" size={14} />
              {provider?.infos?.staffRole}
            </StyleTag>
            <StyleTag>{provider?.infos?.qualification}</StyleTag>
          </Row>
        </StyleRightWrapper>
      </StyleRowWrapper>
      <Row colGap={10}>
        <Button
          title="Remove"
          styleButton="width:100%;"
          styleButtonWrapper="width:49%;"
          outline
          data-cross-id={provider?.id}
          data-cross-type={'Remove'}
        />
        <Button
          title="Edit"
          styleButton="width:100%;"
          styleButtonWrapper="width:49%;"
          data-cross-id={provider?.id}
          data-cross-type={'Edit'}
        />
      </Row>
    </StyleCard>
  )
}

export default InstituteProviderCard
